import React, { useRef } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { TextField, Button, Form, Typography, Stack } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction, refIsRequiredError } from "@util/utils";
import useInBodyApi from "@apis/useInBodyApi";

/**
 * 每次量身設定的 X-Factor 與運動目標
 * 重要註解：
 * - `xFactorNotes` 是一個陣列。
 * - `xFactorNotes[0]` 表示「動機與目的」，`xFactorNotes[1]` 表示「運動目標」。
 * - 注意：這是上線後新增的需求，團隊決定不改變既有資料結構（xFactorNotes 保持陣列格式），
 *   因此透過索引 [0] 和 [1] 固定對應動機與目的、運動目標。後續維護時需留意此約定。
 */
const InBodyXFactorDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData = [], onClose, refresh } = props;
	if (!open) return null;
	const { list, memberID, measureID } = sourceData || {};
	const { postXFactorApi } = useInBodyApi();

	const xFactorRef = useRef(null);
	const fitnessGoalRef = useRef(null);

	const doMemberProfileNotesApi = async (memberID, measureID, params) => {
		let resp = await postXFactorApi(memberID, measureID, params);
		if (resp) {
			isFunction(refresh) && refresh();
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		let isError = refIsRequiredError(xFactorRef, fitnessGoalRef);
		if (!isError) {
			let params = [
				{
					measureTaskID: list?.[0]?.measureTaskID || 0,
					taskTitle: xFactorRef.current && xFactorRef.current.getResult && xFactorRef.current.getResult(),
				},
				{
					measureTaskID: list?.[1]?.measureTaskID || 0,
					taskTitle: fitnessGoalRef.current && fitnessGoalRef.current.getResult && fitnessGoalRef.current.getResult(),
				},
			];
			doMemberProfileNotesApi(memberID, measureID, params);
		}
	};
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>X-Factor 與運動目標</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid xs={3} item>
						<Stack className={"h-100"} justifyContent={"end"} alignItems={"center"}>
							<Typography className={"text-right mb-0"}>動機與目的</Typography>
						</Stack>
					</Grid>
					<Grid xs={9} item>
						<TextField ref={xFactorRef} key={list?.[0]?.taskTitle} defaultValue={list?.[0]?.taskTitle} fullWidth />
					</Grid>
					<Grid xs={3} item>
						<Stack className={"h-100"} justifyContent={"end"} alignItems={"center"}>
							<Typography className={"text-right mb-0"}>運動目標</Typography>
						</Stack>
					</Grid>
					<Grid xs={9} item>
						<TextField ref={fitnessGoalRef} key={list?.[1]?.taskTitle} defaultValue={list?.[1]?.taskTitle} fullWidth />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default InBodyXFactorDialog;
